// Import the RTK Query methods from the React-specific entry point
import { Paths } from './paths/paths';
import { cameliseDeep } from '@utils/functions/camelise';
import { apiSlice } from './apiSlice';
import { UserPortfolio } from './response/UserPortfolio';
import { UserTransaction } from './response/UserTransactions';
import { ProductReport } from './response/ProductReport';

export const productSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userPortfolio: builder.query<UserPortfolio, void>({
      query: () => Paths.UserPortfolio,
      transformResponse: (data: unknown) => cameliseDeep<UserPortfolio>(data),
    }),
    userTransactions: builder.query<UserTransaction[], void>({
      query: () => Paths.UserTransactions,
      transformResponse: (data: unknown) =>
        cameliseDeep<UserTransaction[]>(data),
    }),
    userProductReports: builder.query<ProductReport[], void>({
      query: () => Paths.UserProductReports,
      transformResponse: (data: unknown) => cameliseDeep<ProductReport[]>(data),
    }),
  }),
});

export const {
  useUserPortfolioQuery,
  useLazyUserPortfolioQuery,
  useUserTransactionsQuery,
  useUserProductReportsQuery
} = productSlice;
